export enum GrantType {
    Gestor = 'gestor',
    RefreshTokenGestor = 'refresh_token_gestor'
}
